<template>
    <div>
        <div id="editor"></div>
        <zenya-dialog v-model="showCreateHyperlinkInternal" :title="$t('createHyperlink.createHyperlink')" :showOk="false" :scrollable="true">
            <create-hyperlink :show-modal="showCreateHyperlinkInternal" @close-create-hyperlink="closeCreateHyperlink" :sourceType="sourceType" />
        </zenya-dialog>
    </div>
</template>
<style lang="scss" scoped>
#editor {
    height: 200px;
}
</style>
<style lang="scss">
.ql-tooltip {
    visibility: hidden !important;
}

.ql-container {
    font-size: 16px !important;
    font-family: "Roboto, sans-serif";
    color: rgba(0, 0, 0, 0.87);
}
</style>
<script>
import Quill from "quill";
import { HyperlinkItem } from "@/types/HyperlinkItem";
import CreateHyperlink from "../dialogs/CreateHyperlink.vue";
import ZenyaDialog from "../dialogs/ZenyaDialog.vue";
import Shared from "../../shared";
import { SourceType } from "@/enums";
import { Constants } from "@/constants";

export default {
    name: "QuillEditor",
    components: { CreateHyperlink, ZenyaDialog },
    props: {
        placeholderKey: String,
        placeholderText: String,
        customToolbarOptions: null,
        existingContent: String
    },
    data: function () {
        return {
            quill: Object,
            showCreateHyperlinkInternal: false,
            sourceType: SourceType.NewsArticle,
            currentSelection: Object
        };
    },
    mounted() {
        this.initQuillEditor();
    },
    methods: {
        openCreateHyperlink() {
            this.showCreateHyperlinkInternal = true;
        },
        async closeCreateHyperlink(hyperlinkItem) {
            if (hyperlinkItem) {
                const href = Shared.iProvaUrl + "/management/hyperlinkloader.aspx?hyperlinkid=" + hyperlinkItem.id;
                this.quill.formatText(this.currentSelection.index, this.currentSelection.length, "link", href);
                this.quill.focus();
            }
            this.showCreateHyperlinkInternal = false;
        },
        emitHtmlContent(value) {
            this.$emit("text-change", value);
            this.$emit("change");
        },
        linkHandler(value) {
            if (value) {
                this.quill.focus();
                this.currentSelection = this.quill.getSelection();
                if (this.currentSelection.length > 0) {
                    this.openCreateHyperlink();
                }
            } else {
                this.quill.format("link", false);
            }
        },
        initQuillEditor() {
            function loaded(result) {
                const range = this.quill.getSelection();
                this.quill.insertEmbed(range.index, "image", result.target.result, "user");
                this.quill.setSelection(range.index + 1);
            }

            function imageSelected(e) {
                const file = e.target.files[0];

                // file type is only image.
                if (/^image\//.test(file.type)) {
                    //this is needed due ot context changed
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = loaded.bind(this);
                } else {
                }
            }

            function imageHandler() {
                const input = document.createElement("input");
                input.setAttribute("type", "file");
                input.setAttribute("accept", "image/*");
                // Listen upload local image and save to server
                input.addEventListener("change", imageSelected.bind(this));
                input.click();
            }

            const toolbarOptions = !this.customToolbarOptions ? Constants.QuillEditor.defaultToolbarOptions : this.customToolbarOptions;
            this.quill = new Quill("#editor", {
                modules: {
                    toolbar: toolbarOptions
                },
                placeholder: this.placeholderText === undefined ? this.$t(this.placeholderKey) : this.placeholderText,
                theme: "snow"
            });

            const toolbar = this.quill.getModule("toolbar");
            toolbar.addHandler("link", this.linkHandler);
            toolbar.addHandler("image", imageHandler);

            this.quill.on(
                "text-change",
                function (delta, oldDelta, source) {
                    const value = this.quill.root.innerHTML;
                    this.emitHtmlContent(value);
                }.bind(this)
            );

            this.quill.updateContents(this.quill.clipboard.convert(this.existingContent === undefined ? "" : this.existingContent), "api");
        }
    }
};
</script>
